import { render, staticRenderFns } from "./ColumnIntelligence.vue?vue&type=template&id=6ed3eecb"
import script from "./ColumnIntelligence.vue?vue&type=script&lang=js"
export * from "./ColumnIntelligence.vue?vue&type=script&lang=js"
import style0 from "./ColumnIntelligence.vue?vue&type=style&index=0&id=6ed3eecb&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ed3eecb')) {
      api.createRecord('6ed3eecb', component.options)
    } else {
      api.reload('6ed3eecb', component.options)
    }
    module.hot.accept("./ColumnIntelligence.vue?vue&type=template&id=6ed3eecb", function () {
      api.rerender('6ed3eecb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/List/ColumnIntelligence.vue"
export default component.exports